module.exports = __webpack_public_path__ + "static/img/04.50b477b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/ldt/04.png
// module id = 13Rm
// module chunks = 0